import LaunchIcon from '@mui/icons-material/Launch'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'

import { DisciplineIcon } from '@components/DisciplineIcon'
import { formatDate } from '@util/date-util'

import type { HoofdnetOpdracht } from '../../../opdracht/hoofdnet/types/HoofdnetOpdracht'
import { StyledIconLink } from '../../../theme/components/StyledIconLink'

interface Props {
  opdracht: HoofdnetOpdracht
}

export const HoofdnetOpdrachtenTableRow = ({ opdracht }: Props) => {
  return (
    <>
      <TableRow key={opdracht.opdrachtId}>
        <TableCell>{opdracht.opdrachtId}</TableCell>
        <TableCell>{opdracht.versieNummer}</TableCell>
        <TableCell>
          <DisciplineIcon
            disciplineCode={opdracht.details?.discipline || ''}
            toolTip={opdracht.details?.disciplineLabel || ''}
          />
        </TableCell>
        <TableCell>{opdracht.opdrachtgever}</TableCell>
        <TableCell>{opdracht.opdrachtnemer}</TableCell>
        <TableCell>
          {formatDate(opdracht.created) ||
            /* v8 ignore next - TODO: missing coverage -- @preserve */ 'Onbekend'}
        </TableCell>
        <TableCell>{formatDate(opdracht.changed)}</TableCell>
        <TableCell>{opdracht.statusText}</TableCell>
        <TableCell>
          <StyledIconLink
            title={`Navigeer naar opdracht ${opdracht.opdrachtId}`}
            icon={<LaunchIcon />}
            href={`/hoofdnetopdracht/${opdracht.opdrachtId}`}
          />
        </TableCell>
      </TableRow>
    </>
  )
}
